import React, { Component } from 'react';
// import { EditorState, convertFromRaw, convertToRaw, convertFromHTML } from 'draft-js';
import {
  // Editor,
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
  compositeDecorator
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
class Draft extends Component {
  constructor(props) {
    super(props);
    this.state = {

      garmentTechnologist: null,
      test: ''
    };


  }

  componentWillMount() {
    const { value } = this.props;
    if (value){

      const blocksFromHTML = convertFromHTML(value);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
      this.state = {
        editorState: EditorState.createWithContent(
          state,
          compositeDecorator,
        ),
      };
    }
  }

  onEditorStateChange = (editorState) => {
    const { garmentTechnologist } = this.props;
    let test = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    this.props.editorText(test, this.props.editorType, this.props.editorSubType)
    this.setState({ editorState, test, garmentTechnologist });
  }
  render() {
    const { editorState } = this.state;
    return (
      <div>
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          inputName="comments"
          onEditorStateChange={this.onEditorStateChange}
          value={this.props.value}
        />
        <textarea

          id="draftContent"
        />
      </div>
    );
  }
}

export default Draft;


// WEBPACK FOOTER //
// ./src/components/SampleRequest/GarmentTechModule/draft.js